<h1 style="display: flex; align-items: center;">
	<img src="../../../../../assets/images/icons/flags/3x2/IT.svg" alt="IT Flag"
		style="width:auto; height:20px; margin-right: 10px;">
	COME ASSOCIARSI
</h1>
<div class="text">
	<p><strong> English version below </strong></p>
	<p> Dal 1 Gennaio al 30 Ottobre di ogni anno possono fare richiesta di associazione a De Cifris tutte le persone fisiche
		che ne condividano le finalità, presentando domanda al consiglio direttivo
		secondo la seguente modalità:
	</p>
	<ol>
		<li>
			Compilare la <a href="https://drive.google.com/file/d/1kPvi8FLMv9r7dwCMW8rH2HBGqN7FJ4Bd">Domanda di
				associazione</a>.
		</li>
		<li>
			Leggere e sottoscrivere <a
				href="https://drive.google.com/file/d/1OwBOJRJ_7eCq03HHYHBaKBASFhNxTbmz">l'Informativa sul
				trattamento dei dati personali</a>.
		</li>
		<li>
			Effettuare il pagamento della quota associativa definita come segue:
			<ul>
				<li>
					Socio/a ordinario/a: EUR 40,00.
				</li>
				<li>
					Socio/a giovane (età inferiore a 35 anni): EUR 15,00.
				</li>
			</ul>
		</li>
		<li>
			Inviare i moduli compilati, la ricevuta del pagamento
			e una copia del documento di identità (carta d'identità o passaporto)
			all'indirizzo email <a href="mailto:soci@decifris.it">soci&#64;decifris.it</a>.
		</li>
	</ol>
	<p>
		La domanda di ammissione verrà vagliata dal consiglio direttivo che dovrà esprimersi a tale
		riguardo entro centoventi giorni dalla ricezione della domanda. <br>
		Per quanto riguarda i soci benemeriti, la procedura è indicata
		a <a routerLink="/associazione/associarsi-benemeriti">questa pagina</a>.
	</p>
	<h2>Perché associarsi?</h2>
	<p>
		Ci sono numerosi vantaggi nell'associarsi:
	</p>
	<ul>
		<li>
			<a href="../../../assets/pdf/associarsi/vantaggi_associarsi_DC_giovani.pdf">Per i giovani</a>: trovare
			stage, tirocini e offerte di lavoro, come riassunto
			qui.
		</li>
		<li>
			<a href="../../../assets/pdf/associarsi/vantaggi_associarsi_DC.pdf">Per gli interessati</a>:
			sconti su eventi ed iniziative - non solo nostri! - e partecipazione a progetti.
		</li>
	</ul>
	<h2>Modalità di pagamento</h2>
	<p>
		Pagamento tramite bonifico su conto corrente intestato a:
		<br>
		<br>
		Associazione De Componendis Cifris
		<br>
		IBAN: IT 61 Q 08304 01810 000010412063
		<br>
		BIC/SWIFT: CCRTIT2T76A
		<br>
		Cassa di Trento Credito Cooperativo Italiano
		<br>
		Causale:
	</p>
	<ul>
		<li>
			Associato/a ordinario/a: “Quota socio/a ordinario/a Nome Cognome”
		</li>
		<li>
			Associato/a giovane: “Quota socio/a giovane Nome Cognome”

		</li>
	</ul>
</div>












<h1 style="display: flex; align-items: center;">
	<img src="../../../../../assets/images/icons/flags/3x2/GB.svg" alt="GB Flag"
		style="width:auto; height:20px; margin-right: 10px;">
	HOW TO BECOME A MEMBER
</h1>

<div class="text">
	<p><strong>Italian version above</strong></p>
	<p>From January 1st to October 30th of each year, any individual who shares the goals of De Cifris can apply for membership by submitting an application to the
		Board
		of Directors in the following manner:</p>
	<ol>
		<li>
			Complete the <a href="https://drive.google.com/file/d/1Fo7SnTX_Wwr0YhryM2usyyMDOS605wCW">Membership
				Application
				Form</a>.
		</li>
		<li>
			Read and sign the <a href="https://drive.google.com/file/d/1_kAvJbTpo_tzT3UxJBSnPkN7n-z0clLA">Privacy
				Policy</a>.
		</li>
		<li>
			Pay the membership fee as follows:
			<ul>
				<li>
					Ordinary Member: EUR 40.00.
				</li>
				<li>
					Young Member (under 35 years old): EUR 15.00.
				</li>
			</ul>
		</li>
		<li>
			Send the completed forms, proof of payment, and a copy of your ID (identity card or passport) to the email
			address <a href="mailto:soci@decifris.it">soci&#64;decifris.it</a>.
		</li>
	</ol>
	<p>
		The Board of Directors will review the membership application and must respond within one hundred and twenty
		days of
		receiving the application. <br>
		For information regarding honorary members, the procedure is indicated <a
			routerLink="/associazione/associarsi-benemeriti">on this page</a>.
	</p>
	<h2>Why become a member?</h2>
	<p>
		There are numerous benefits to becoming a member:
	</p>
	<ul>
		<li>
			<a href="../../../assets/pdf/associarsi/vantaggi_associarsi_DC_giovani.pdf">For young people</a>: find
			internships, training opportunities, and job offers, as summarized here.
		</li>
		<li>
			<a href="../../../assets/pdf/associarsi/vantaggi_associarsi_DC.pdf">For those interested</a>: discounts on
			events and initiatives—not only ours!—and participation in projects.
		</li>
	</ul>
	<h2>Payment Method</h2>
	<p>
		Payment can be made via bank transfer to the account in the name of:
		<br>
		<br>
		Associazione De Componendis Cifris
		<br>
		IBAN: IT 61 Q 08304 01810 000010412063
		<br>
		BIC/SWIFT: CCRTIT2T76A
		<br>
		Cassa di Trento Credito Cooperativo Italiano
		<br>
		Purpose:
	</p>
	<ul>
		<li>
			Ordinary Member: "Ordinary Member Fee Name Surname"
		</li>
		<li>
			Young Member: "Young Member Fee Name Surname"
		</li>
	</ul>
</div>